// Modern Swiper import (v9+)
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function init() {
  const sliders = document.querySelectorAll(".swiper-container");

  if (!sliders.length) return;

  setup();
}

function setup() {
  return new Swiper(".swiper-container", {
    speed: 500,
    loop: false,
    allowTouchMove: false,
    preventClicks: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
}

export default init;
